import { Component } from '@angular/core';

@Component({
  selector: 'app-apply-for-job',
  templateUrl: './apply-for-job.component.html',
  styleUrls: ['./apply-for-job.component.scss'],
})
export class ApplyForJobComponent {
  labelText: string[] = [
    'Cliquez pour parcourir ou glissez',
    '-déposez vos fichiers',
  ];
  onFileSelected(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files && inputElement.files.length > 0) {
      const selectedFile = inputElement.files[0];
      this.labelText[0] = 'Fichier sélectionné :';
      this.labelText[1] = selectedFile.name;
    }
  }
}
